import Vue from 'vue'
import numberFormat from 'locutus/php/strings/number_format'
import postscribe from 'postscribe'
import * as d3 from 'd3v4'

const NumberFormatPlugin = {
    install () {
        Vue.prototype.$_getNumberFormat = (number, decimal) => {
            const decimalPoint = typeof decimal === 'number' ? decimal : 2
            return numberFormat(number, decimalPoint)
        }
    }
}

const NumberWonFormatPlugin = {
    install () {
        Vue.prototype.$_getWon = (number, decimal) => {
            const decimalPoint = typeof decimal === 'number' ? decimal : 0
            if (parseFloat(number) < 0) {
                return '-￦ ' + numberFormat(Math.abs(number), decimalPoint)
            } else {
                return '￦ ' + numberFormat(number, decimalPoint)
            }
        }
    }
}
const NumberDollarFormatPlugin = {
    install () {
        Vue.prototype.$_getDollar = (number, decimal) => {
            const decimalPoint = typeof decimal === 'number' ? decimal : 2
            if (parseFloat(number) < 0) {
                return '-$ ' + numberFormat(Math.abs(number), decimalPoint)
            } else {
                return '$ ' + numberFormat(number, decimalPoint)
            }
        }
    }
}

const NumberRatioFormatPlugin = {
    install () {
        Vue.prototype.$_getRatio = (number) => {
            return `${numberFormat(number, 2).toString()}%`
        }
    }
}

const NumberAmountFormatPlugin = {
    install () {
        Vue.prototype.$_getAmount = (number, type) => {
            if (type.indexOf('DataTransfer') > -1) {
                return `${numberFormat(number, 2)} GB`
            } else if (type.indexOf('Requests') > -1) {
                return `${numberFormat(number, 0)} Requests`
            } else {
                return numberFormat(number, 2)
            }
        }
    }
}

const NonAllatPayREPlus = {
    install () {
        Vue.prototype.$_allatPayPlus = () => {
            if (!document.body.querySelector('#ALLAT_PLUS_PAY')) {
                postscribe(document.body, '<script src="https://tx.allatpay.com/common/NonAllatPayREPlus.js" charset="euc-kr"></script>')
                // postscribe(document.head, '<script src="/vendor/NonAllatPayREPlus.js" charset="euc-kr"></script>')
            }
        }
    }
}

const NonAllatPayEN = {
    install () {
        Vue.prototype.$_allatPayEN = () => {
            if (!document.body.querySelector('#ALLAT_PAY')) {
                postscribe(document.body, '<script src="https://tx.allatpay.com/common/NonAllatPayEN.js" charset="euc-kr"></script>')
            }
        }
    }
}

const NonAllatPayRE = {
    install () {
        Vue.prototype.$_allatPay = () => {
            if (!document.body.querySelector('#ALLAT_PAY')) {
                postscribe(document.body, '<script src="https://tx.allatpay.com/common/NonAllatPayRE.js" charset="euc-kr"></script>')
            }
        }
    }
}

const D3v4Plugin = {
    install () {
        Vue.prototype.$d3 = d3
    }
}

Vue.use(NumberFormatPlugin)
Vue.use(NumberWonFormatPlugin)
Vue.use(NumberDollarFormatPlugin)
Vue.use(NumberRatioFormatPlugin)
Vue.use(NumberAmountFormatPlugin)
Vue.use(NonAllatPayREPlus)
Vue.use(NonAllatPayEN)
Vue.use(NonAllatPayRE)
Vue.use(D3v4Plugin)
